// ** Next Imports
import Image from "next/image";

// ** FA Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faCheck } from "@fortawesome/free-solid-svg-icons";

// ** File Imports
import Layout, { SEOHead } from "../../layouts/default";

// ** Data Imports
import { WHY_CHOOSE_EIN, REVIEWS } from "../../helpers/DATA";

// ** Image imports
import aboutIconImg1 from "../../../public/images/about-icon1.jpg";
import aboutIconImg2 from "../../../public/images/about-icon2.jpg";
import aboutIconImg3 from "../../../public/images/about-icon3.jpg";

import contactImage1 from "../../../public/images/contact-1.jpg";
import contactImage2 from "../../../public/images/contact-2.jpg";
import contactImage3 from "../../../public/images/contact-3.jpg";

const Star5 = () => (
  <span>
    <FontAwesomeIcon icon={faStar} color="#f8bd06" />
    <FontAwesomeIcon icon={faStar} color="#f8bd06" />
    <FontAwesomeIcon icon={faStar} color="#f8bd06" />
    <FontAwesomeIcon icon={faStar} color="#f8bd06" />
    <FontAwesomeIcon icon={faStar} color="#f8bd06" />
  </span>
);

const About = () => (
  <Layout>
    <SEOHead title="Internet Service Providers USA | No Credit Check Internet">
      <meta
        name="description"
        content="EIN is the internet service provider in USA that has no bundles, contracts or credit checks involved. Unlimited high speed Internet for both business and homes."
      ></meta>
      <meta
        name="keywords"
        content="internet service providers usa, unlimited high speed internet, high speed business internet, no contract internet providers, no credit check internet"
      />
    </SEOHead>

    <section className="pad-top-60 pad-bot-60 custom-border2">
      <div className="container">
        <div className="row equal-col">
          <div className="col-md-6 col-lg-6 col-sm-12 col-12">
            <div className="textual-sec1">
              <h3> No Contract, No Credit Check, No Hassle </h3>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 col-12">
            <div className="textual-sec2">
              <h5 className="col-grey1">
                EIN brings the best networks and speed to our customers without
                the need for contracts or credit checks. You get a connection
                that is reliable, from a company that makes Internet service
                easy to understand.
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="pad-top-40 pad-bot-40">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-lg-4 col-sm-4 col-12">
            <div className="about-box">
              <Image
                src={aboutIconImg1}
                className="img-fluid"
                placeholder="blur"
                alt="About Icon"
              />

              <h5 className="col-black"> Free WIFI Modem </h5>
              <p className="col-grey1">
                Every EIN installation includes a free WIFI modem to provide
                service across your home or business. Plus, it&apos;s yours! No
                need to return or pay a lease charge!
              </p>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-4 col-12">
            <div className="about-box">
              <Image
                src={aboutIconImg2}
                className="img-fluid"
                placeholder="blur"
                alt="About Icon 2"
              />
              <h5 className="col-black"> No Contract or Credit Check </h5>
              <p className="col-grey1">
                We never run a credit check or change pricing based on your
                credit history. You can cancel at any time without a penalty.
                Best part? No hidden fees!
              </p>
            </div>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-4 col-12">
            <div className="about-box">
              <Image
                src={aboutIconImg3}
                className="img-fluid"
                placeholder="blur"
                alt="About Icon 3"
              />
              <h5 className="col-black"> Unlimited Internet </h5>
              <p className="col-grey1">
                We never throttle or cap your speed because of how much
                you&apos;ve used your Internet service. This is Internet service
                the way it was meant to be enjoyed!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="pad-top-40 pad-bot-60">
      <div className="container">
        <div className="row custom-row1">
          <div className="col-md-4 col-lg-4 col-sm-4 col-12 custom-pad1">
            <div className="custom-image1">
              <Image
                src={contactImage1}
                className="img-fluid"
                placeholder="blur"
                alt="Contact Image"
              />
            </div>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-4 col-12 custom-pad1">
            <div className="custom-image1">
              <Image
                src={contactImage2}
                className="img-fluid"
                placeholder="blur"
                alt="Contact Image 2"
              />
            </div>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-4 col-12 custom-pad1">
            <div className="custom-image1">
              <Image
                src={contactImage3}
                className="img-fluid"
                placeholder="blur"
                alt="Contact Image 3"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-silver2 pad-top-80 pad-bot-80">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12 col-12">
            <div className="block-element m-b-30">
              <div className="textual-sec1">
                <p className="col-black m-b-10">
                  The Nations Best Internet Service
                </p>
                <h3 className="m-b-20">Why Choose EIN</h3>
                <h6 className="line-2">.</h6>
              </div>
            </div>
            <div className="block-element">
              <ul className="list-2">
                {WHY_CHOOSE_EIN.map((itm, index) => (
                  <li key={index}>
                    <FontAwesomeIcon icon={faCheck} /> {itm}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 col-12">
            <div className="block-element">
              <div className="textual-sec3">
                <h4 className="col-black"> How does EIN work? </h4>
                <p className="col-grey1">
                  EIN uses existing service lines already at your home or
                  business to provide the best Internet connection. All
                  installations are completed by a Professional Technician to
                  make sure you get a quality connection and any help you might
                  need connecting your devices to your new network.
                </p>
                <p className="col-grey1">
                  Not only do you get a great Internet connection, but you also
                  get support from our fantastic dedicated Support Team. You can
                  connect with us through Facebook Messenger, text, phone, and
                  live chat!
                </p>
              </div>
            </div>
            <div className="block-element m-b-20">
              <div className="progress-title">
                <h5>
                  Customer Satisfaction <b>96%</b>
                </h5>
              </div>
              <div className="progress progress-1">
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{ width: "96%" }}
                ></div>
              </div>
            </div>
            <div className="block-element">
              <div className="progress-title2">
                <h5>
                  <Star5 />
                  <b> 4.8/5 </b>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/easyinternetnow/reviews"
                  >
                    Facebook Reviews
                  </a>
                </h5>
              </div>
              <div className="progress-title">
                <h5>
                  Network Up-Time <b> 99% </b>
                </h5>
              </div>
              <div className="progress progress-1">
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{ width: "99%" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="pad-top-60 pad-bot-60">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12 col-12">
            <div className="block-element m-b-20">
              <div className="textual-sec3">
                <h4 className="col-black"> Want to learn more? </h4>
                <p className="col-grey1">
                  Watch this video to see how EIN operates, and how we bring you
                  the best speeds and service!
                </p>
              </div>
            </div>
            <div className="block-element">
              <div className="video-1">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/NGVlLyO9m1Y"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 col-12">
            <div className="block-element m-b-20">
              <div className="textual-sec3">
                <p className="col-grey1">
                  Affordable price and no contract is the best part. If my
                  internet is not working properly, the issue is always resolved
                  the same day; even though there are rare instances. Great
                  company, I recommend their service.
                </p>
              </div>
            </div>

            <div className="block-element">
              {REVIEWS.map((review, index) => (
                <div className="review-box" key={index}>
                  <div className="review-title">
                    {review.img}
                    <h5>{review.name}</h5>
                    <h6>{review.from}</h6>
                    <Star5 />
                  </div>
                  <div className="review-desc">
                    <p>{review.review}</p>
                  </div>
                </div>
              ))}

              <div className="block-element">
                <div className="progress-title2">
                  <h5>
                    <Star5 />
                    <b> 4.8/5 </b>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/easyinternetnow/reviews"
                      rel="noopener noreferrer"
                    >
                      Facebook Reviews
                    </a>
                  </h5>
                </div>
                <div className="progress-title2">
                  <h5>
                    <Star5 />
                    <b> 5/5 </b>
                    <a
                      target="_blank"
                      href="https://g.page/EIN_Internet?gm"
                      rel="noopener noreferrer"
                    >
                      Google Reviews
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default About;
